import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { money } from "utils/helpers";
import { SalesStockStatusOptions } from "utils/Constant";

/**
 * Exports the Sales Stock list to a PDF file.
 * @param {Array} listData - array of sales stock rows (same shape as salesStockList?.data?.listData)
 * @param {Object} meta - { groupBy } - '1' = detail view, otherwise grouped view
 */
export function exportSalesStockToPdf(listData = [], meta = {}) {
    const { groupBy = "1" } = meta;

    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    doc.setFontSize(14);
    doc.text("Laporan Stock Penjualan", 40, 40);

    const isDetail = groupBy === "1";

    const columns = isDetail
        ? [
              { header: "No", dataKey: "rowNumber" },
              { header: "Kode Stock", dataKey: "stockCode" },
              { header: "Nama Product", dataKey: "productName" },
              { header: "Size", dataKey: "size" },
              { header: "Purchase Price", dataKey: "purchasePrice" },
              { header: "Stock Status", dataKey: "stockStatus" },
              { header: "Status", dataKey: "status" },
          ]
        : [
              { header: "No", dataKey: "rowNumber" },
              { header: "Kode Stock", dataKey: "productName" },
              { header: "Size", dataKey: "size" },
              { header: "Stock Status", dataKey: "stockStatus" },
              { header: "Total Stock", dataKey: "totalStock" },
          ];

    const rows = isDetail
        ? listData.map((row, i) => ({
              rowNumber: i + 1,
              stockCode: row.stockCode,
              productName: row.productName,
              size: row.size,
              purchasePrice: `Rp ${money(row.purchasePrice)}`,
              stockStatus:
                  SalesStockStatusOptions.find((x) => x.value === String(row.stockStatus))?.label ?? "-",
              status: row.status ? "Active" : "Inactive",
          }))
        : listData.map((row, i) => ({
              rowNumber: i + 1,
              productName: `${row.brandName} ${row.productName}`,
              size: row.size,
              stockStatus: row.stockStatus,
              totalStock: row.totalStock,
          }));

    autoTable(doc, {
        startY: 58,
        columns,
        body: rows,
        styles: { fontSize: 8, cellPadding: 4 },
        headStyles: { fillColor: [30, 30, 30], textColor: 255 },
    });

    const fileName = `sales-stock-${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(fileName);
}